export enum RouteName {
  ActiviteitenAfspraken = 'ActiviteitenAfspraken',
  ActiviteitenActiviteitenOverzicht = 'ActiviteitenActiviteitenOverzicht',
  ActiviteitenDocumenten = 'ActiviteitenDocumenten',
  ActiviteitenOverzicht = 'ActiviteitenOverzicht',
  Admin = 'AdminIndex',
  AdminUserTools = 'AdminUserTools',
  AdminFeatureFlags = 'AdminFeatureFlags',
  AdminOrganisations = 'AdminOrganisations',
  AdminNotificationAfterLogin = 'AdminNotificationAfterLogin',
  AdminVerwerkersovereenkomst = 'AdminVerwerkersovereenkomst',
  AdminDevelopmentToggles = 'AdminDevelopmentToggles',
  BeheerZvdZRequestAccess = 'BeheerZvdZRequestAccess',
  ContactIndex = 'ContactIndex',
  ContractenIndex = 'ContractenIndex',
  FacturenIndex = 'FacturenIndex',
  GebruikersBeheer = 'GebruikersBeheerIndex',
  GebruikersBeheerGebruiker = 'GebruikersBeheerGebruiker',
  GebruikersBeheerGebruikers = 'GebruikersBeheerGebruikers',
  GebruikersBeheerVervangingRegelen = 'GebruikersBeheerVervangingRegelen',
  GebruikersBeheerTwoFactor = 'GebruikersBeheerTwoFactor',
  GebruikersvoorwaardenIndex = 'GebruikersvoorwaardenIndex',
  PaginaNietGevonden = 'PaginaNietGevonden',
  HomeNietGeautoriseerd = 'HomeNietGeautoriseerd',
  HomeIndex = 'HomeIndex',
  InterventiesIndex = 'InterventiesIndex', // deprecated
  LoggedOut = 'LoggedOut',
  LoginGebruikersNaamWijzigen = 'LoginGebruikersNaamWijzigen',
  LoginIndex = 'LoginIndex',
  Logout = 'Logout',
  LoginPasswordRecovery = 'LoginPasswordRecovery',
  LoginActivatie = 'LoginActivatie',
  MijnProfielBevestigContactgegevens = 'MijnProfielBevestigContactgegevens',
  MijnProfielIndex = 'MijnProfielIndex',
  MijnProfielMijnAccount = 'MijnProfielMijnAccount',
  MijnProfielMijnAutorisatie = 'MijnProfielMijnAutorisatie',
  MijnProfielMijnVervanging = 'MijnProfielMijnVervanging',
  OnlineStoreIndex = 'OnlineStoreIndex', // deprecated
  ProlongatieIndex = 'ProlongatieIndex',
  RapportenBasisDashboard = 'RapportenBasisDashboard',
  RapportenUitgebreidDashboard = 'RapportenUitgebreidDashboard',
  RapportenBasis = 'RapportenBasis',
  RapportenVerzuimhistorie = 'RapportenVerzuimhistorie',
  RapportenWgaStatus = 'RapportenWgaStatus',
  RapportenWAOStatus = 'RapportenWAOStatus',
  RapportenNoRiskpolis = 'RapportenNoRiskpolis',
  RapportenZiekUitDienst = 'RapportenZiekUitDienst',
  RapportenUitDienst = 'RapportenUitDienst',
  RapportenExport = 'RapportenExport',
  RegistratieAanmelden = 'RegistratieAanmelden',
  SchadelastbeheersingSchadelastbeheersing = 'SchadelastbeheersingSchadelastbeheersing',
  Settings = 'SettingsIndex',
  SettingsInformatie = 'SettingsInformatie', // deprecated
  SettingsAssurantie = 'SettingsAssurantie',
  SettingsVerzuimProtocol = 'SettingsVerzuimProtocol',
  SettingsOrganisatieProtocol = 'SettingsOrganisatieProtocol',
  SettingsModules = 'SettingsModules', // deprecated
  SettingsSjablonen = 'SettingsSjablonen', // deprecated
  SettingsCorrespondentie = 'SettingsCorrespondentie',
  SsoNietGeautoriseerd = 'SsoNietGeautoriseerd',
  TriageWG = 'TriageWG',
  TriageWN = 'TriageWN',
  UwGegevensIndex = 'UwGegevensIndex',
  VerwerkersovereenkomstIndex = 'VerwerkersovereenkomstIndex',
  VideogesprekIndex = 'VideogesprekIndex',
  WerknemerDossierVRDossier = 'WerknemerDossierVRDossier',
  WerknemerDossierWgaDossier = 'WerknemerDossierWgaDossier',
  WerknemerIndex = 'WerknemerIndex',
  WerknemerCorrespondentie = 'WerknemerCorrespondentie',
  WerknemerMijnTaken = 'WerknemerMijnTaken',
  WerknemerAfspraken = 'WerknemerAfspraken',
  WerknemerWerknemer = 'WerknemerWerknemer',
  WerknemerPersoonsgegevens = 'WerknemerPersoonsgegevens',
  WerknemerWerknemersgegevens = 'WerknemerWerknemersgegevens',
  WerknemerDienstverband = 'WerknemerDienstverband',
  WerknemerVerzuimHistorie = 'WerknemerVerzuimHistorie',
  WerknemerVerzuimkalender = 'WerknemerVerzuimkalender',
  WerknemerDossiertoegang = 'WerknemerDossiertoegang',
  WrongPortal = 'WrongPortal',
  ZelfserviceIndex = 'ZelfserviceIndex',
  CatchAll = 'CatchAll',
}
